import $ from "jquery";
import Splide from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';
import { Counter, Steps, AdjustableHeight } from './SplideExtensions';
import Em from "./Em";

class Slider extends Em {
	constructor() {
		super();
        this.init();
	}

	init() {
		this.selfDom();
		
		// init sliders
		this.$sliders.each((i) => {
			const $slider = this.$sliders.eq(i);
			this.initSlider($slider);
		});
	}

	selfDom() {
		this.$sliders = $('.splide');
	}

	initSlider($slider, onReadyCallback) {
		// destroy if is initialized
		if ($slider.data('splide-instance')) this.destroySlider($slider);

		//
		// Set options
		//
		const options = {
			type: 'fade',
			arrows: false,
			pagination: false,
			paginationNumbers: false,
			controlsWrap: true,
			arrowPath: 'M39.311,18.432L23.785,2.906C22.919,2.041 21.514,2.041 20.648,2.906C19.783,3.772 19.783,5.177 20.648,6.043L32.388,17.781L2.257,17.781C1.033,17.781 0.039,18.775 0.039,19.999C0.039,21.223 1.033,22.217 2.257,22.217L32.388,22.217L20.648,33.955C19.783,34.821 19.783,36.226 20.648,37.092C21.083,37.526 21.649,37.743 22.218,37.743C22.784,37.743 23.352,37.526 23.786,37.092L39.312,21.566C40.178,20.701 40.178,19.297 39.312,18.431L39.311,18.432Z',
			perPage: 1,
			perMove: 1,
			gap: 0,
			autoplay: false,
			play: false, // auto play do not work on my environment
			progress: false,
			pauseOnHover: false,
			pauseOnFocus: true,
			adaptiveHeight: true,

			mediaQuery: 'min',
			breakpoints: {
				768: {},
				1200: { 
					adaptiveHeight: false 
				},
				1440: {}
			}
		}

		// extend with data attribute options
		// for easier writing, we use custom attribute (data-splide-options) and eval instead of default data-splide
		let dataOptions = $slider.data('splide-options');
		if (dataOptions) {
			dataOptions = (0, eval)('(' + dataOptions + ')');
			$.extend(true, options, dataOptions);
		}

		// prepare options
		if (options.paginationNumbers) {
			options.pagination = true;
		}

		// disable loop in gutenberg (todo)
		// if (options.type === 'loop' && this.$body.hasClass('block-editor-page')) {
		// 	options.type = 'scroll';
		// 	options.rewind = true;
		// }

		//
		// Init splide
		//
		const splide = new Splide($slider[0], options);
		$slider.data('splide-instance', splide);

		//
		// Before mount events
		//
		this.initPaginationNumbers($slider);
		this.initProgressBar($slider);

		// on ready
		splide.off('ready.Slider');
		splide.on('ready.Slider', () => {
			this.initControlsWrap($slider);

			if (splide.options.arrows) {
				$slider.addClass('splide--has-arrows');
			}

			if (splide.options.pagination) {
				$slider.addClass('splide--has-pagination');
			}

			if (splide.options.play === true) {
				splide.Components.Autoplay.play();
			} else {
				splide.Components.Autoplay.pause();
			}

			if (typeof onReadyCallback === 'function') onReadyCallback();
		});

		// on mounted
		splide.off('mounted.Slider');
		splide.on('mounted.Slider', () => {
			
		});

		// on updated
		splide.off('updated.Slider');
		splide.on('updated.Slider', (options) => {
			if (options.play === true) {
				splide.Components.Autoplay.play();
			} else {
				splide.Components.Autoplay.pause();
			}
		});

		//
		// Mount splide (if has synced slider then it will be mounted after synced slider is initialized)
		//
		const syncedSelector = $slider.data('splide-sync-selector') || null;
		const $syncedSlider = this.$sliders.filter(syncedSelector);

		if ($syncedSlider.length < 1) {
			const syncedSplide = $slider.data('splide-synced-instance');
			
			if (syncedSplide) {
				syncedSplide.sync(splide);
				syncedSplide.mount({Grid, Counter, Steps, AdjustableHeight});
			}

			splide.mount({Grid, Counter, Steps, AdjustableHeight});
		} else {
			$syncedSlider.data('splide-synced-instance', splide);
		}

	}

	initControlsWrap($slider) {
		const splide = $slider.data('splide-instance');
		if (!splide || !splide.options.controlsWrap) return false;
		const sliderId = $slider.attr('id');

		const $controls = $slider.find('> .splide__arrows, > .splide__counter, > .splide__pagination, > .splide__progress');
		let $controlsContainer = $slider.find('.splide__controls--container');
		let $controlsWrap = $slider.find('.splide__controls--wrap');
		
		if ($controlsContainer.length < 1) {
			$controlsContainer = $('<div/>', {class: 'splide__controls--container'});
			$slider.append($controlsContainer);
		}

		if ($controlsWrap.length < 1) {
			$controlsWrap = $('<div/>', {class: 'splide__controls--wrap'});
			$controlsContainer.append($controlsWrap);
		}

		$controls.each((i) => {
			const $control = $controls.eq(i);
			$controlsWrap.append($control);
		})

		splide.off('updated.Slider' + sliderId);
		splide.on('updated.Slider' + sliderId, () => {
			this.initControlsWrap($slider);
		});

		// After destroy slider it wont work - it can be added on resize event (use throttled "resized" event)
		splide.off('destroy.Slider' + sliderId);
		splide.on('destroy.Slider' + sliderId, () => {
			$(window).off('resized.Slider-' + sliderId);
			$(window).on('resized.Slider-' + sliderId, () => {
				this.initControlsWrap($slider);
			});
		});
	}

	initProgressBar($slider) {
		const splide = $slider.data('splide-instance');
		if (!splide || !splide.options.progress) return false;
		const sliderId = $slider.attr('id');

		let $progress = $slider.find('.splide__progress');
		let $progressBar = $slider.find('.splide__progress__bar');

		if ($progress.length < 1) {
			$progress = $('<div/>', {class: 'splide__progress'});
			$slider.append($progress);
		}

		if ($progressBar.length < 1) {
			$progressBar = $('<div/>', {class: 'splide__progress__bar'});
			$progress.append($progressBar);
		}
	}

	initPaginationNumbers($slider) {
		const splide = $slider.data('splide-instance');
		if (!splide || !splide.options.paginationNumbers) return false;
		const sliderId = $slider.attr('id');

		splide.off('pagination:mounted.Slider' + sliderId);
		splide.on('pagination:mounted.Slider' + sliderId, (data) => {
			data.list.classList.add('splide__pagination--numbers');
			
			$.each(data.items, (i, item) => {
				const pageNumber = item.page + 1;
				const buttonText = pageNumber < 10 ? '0' + pageNumber.toString() : pageNumber.toString(); // prepend zero to one digit numbers
				item.button.textContent = buttonText;
			});
		});
	}

	destroySlider($slider) {
		const splide = $slider.data('splide-instance');

		if (splide) {
			splide.destroy();
		}
	}
}

export default Slider;